(function ($, Drupal, drupalSettings) {
  'use strict';

  //
  // UCalgary 'Rex Appeal' Throbber.
  //

  // If the Rex loader does not exist, we are likely dealing
  // with the Admin theme. Dynamically add applicable div...
  if ($('.rex-loading').length === 0) {
    $('body').prepend('<div class="rex-loading"></div>');
  }

  // ...and attach submission event listener to any forms.
  $('form').on('submit', function () {
    if (this.checkValidity()) {
      $('body .rex-loading').show();
    }
  });

  // Make sure it is hidden when page has loaded. Also make sure it is
  // hidden right before page 'unload' to set desired state in bfcache.
  $(window).on('load, pagehide', function () {
    $('body .rex-loading').hide();
  });

  // Also connect display with any Ajax calls.
  // Use a quick 1s timeout to prevent any 'flash' of
  // the throbber if Ajax call has already completed.
  var timeoutId = null;
  $(document).ajaxStart(function () {
    timeoutId = setTimeout(function () {
      $('body .rex-loading').show();
    }, 1000);
  }).ajaxStop(function () {
    clearTimeout(timeoutId);
    $('body .rex-loading').hide();
  });

})(jQuery, Drupal, drupalSettings);
